import PageLayout from "./PageLayout";
import {Button} from "../general/input/Button";
import "../../newStructure/component/style/product/product.css"
import useCheckoutStore from "../../newStructure/cart/store/checkoutStore";
import useSession from "../../newStructure/services/state/session/useSession";
import useCartLoader from "../../newStructure/cart/hooks/useCartLoader";

const CompA = () => {

    const session = useSession();
    const store = useCheckoutStore();
    // const test = useCheckoutStore(state => state.testPrep);

    useCartLoader();

    const runTest = () => {
        store.getCart(session)
    }

    return (
        <Button onClick={runTest}>
            Mini Test
        </Button>
    )

}

const CompB = () => {

    const date = useCheckoutStore(state => state.order?.DateAcct);

    return <p>{date}</p>

}

const PageTest = () => {

    const runTest = async () => {

    }

    return (
        <PageLayout>
            <div style={{minHeight: 600}}>
                <CompA />
                <CompB />
                <Button
                    style={{
                        height: "300px",
                        width: "70vw",
                        margin: "100px auto",
                        textAlign: "center",
                        display: "flex"
                    }}
                    onClick={runTest}>
                    <p style={{
                        margin: "auto auto",
                        fontSize: "10em"
                    }}>Test</p>
                </Button>
            </div>
        </PageLayout>
    )

}

export default PageTest;
